import { z } from 'zod';
import type { EmailTemplateToken } from '@sleed/bizcommerce-api';

/**
 * Email template edit form. Mirrors `EmailTemplateToken`. cd/feml/sub/bd are required; ttype is
 * the TemplateEngineType (0 = Bizweb, 1 = Handlebars); wsid is the optional site. The recipient
 * fields (to/cc/bcc names + emails) are free-text strings as in the legacy textarea editors.
 */
export const emailTemplateSchema = z.object({
	id: z.number().optional(),
	cd: z.string().trim().min(1, 'validation.required').max(100, 'validation.tooLong'),
	fnm: z.string().trim().nullable(),
	feml: z.string().trim().min(1, 'validation.required').email('validation.email'),
	sub: z.string().trim().min(1, 'validation.required'),
	bd: z.string().min(1, 'validation.required'),
	ttype: z.number().int(),
	wsid: z.number().nullable(),
	iv: z.boolean(),
	si: z.number({ message: 'validation.required' }).int(),
	tnms: z.string().nullable(),
	temls: z.string().nullable(),
	cnms: z.string().nullable(),
	cemls: z.string().nullable(),
	bcnms: z.string().nullable(),
	bcemls: z.string().nullable()
});

export type EmailTemplateFormValues = z.infer<typeof emailTemplateSchema>;

export const EMPTY_EMAIL_TEMPLATE: EmailTemplateFormValues = {
	cd: '',
	fnm: null,
	feml: '',
	sub: '',
	bd: '',
	ttype: 0,
	wsid: null,
	iv: true,
	si: 0,
	tnms: null,
	temls: null,
	cnms: null,
	cemls: null,
	bcnms: null,
	bcemls: null
};

export function tokenToForm(token: EmailTemplateToken): EmailTemplateFormValues {
	return {
		id: token.id,
		cd: token.cd ?? '',
		fnm: token.fnm ?? null,
		feml: token.feml ?? '',
		sub: token.sub ?? '',
		bd: token.bd ?? '',
		ttype: token.ttype ?? 0,
		wsid: token.wsid ?? null,
		iv: token.iv ?? false,
		si: token.si ?? 0,
		tnms: token.tnms ?? null,
		temls: token.temls ?? null,
		cnms: token.cnms ?? null,
		cemls: token.cemls ?? null,
		bcnms: token.bcnms ?? null,
		bcemls: token.bcemls ?? null
	};
}

export function formToToken(form: EmailTemplateFormValues): EmailTemplateToken {
	return {
		id: form.id,
		cd: form.cd.trim(),
		fnm: form.fnm?.trim() || null,
		feml: form.feml.trim(),
		sub: form.sub.trim(),
		bd: form.bd,
		ttype: form.ttype,
		wsid: form.wsid,
		iv: form.iv,
		si: form.si,
		tnms: form.tnms,
		temls: form.temls,
		cnms: form.cnms,
		cemls: form.cemls,
		bcnms: form.bcnms,
		bcemls: form.bcemls
	};
}
